import { render, staticRenderFns } from "./PcCase.vue?vue&type=template&id=cb34ea10&scoped=true&"
import script from "./PcCase.vue?vue&type=script&lang=js&"
export * from "./PcCase.vue?vue&type=script&lang=js&"
import style0 from "./PcCase.vue?vue&type=style&index=0&id=cb34ea10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb34ea10",
  null
  
)

export default component.exports